﻿﻿export interface IInvoiceLineItem {
    id: number;
    centerId: number;
    invoiceDate: string;
    description: string;
    applyTo: number;
    applyToDescription: string;
    isCredit: boolean;
    amount: number;
}
